import { matchPath } from "react-router";
import { ROUTES } from "../../../../consts/routes";

export const getPathParams = () => {
  const match = matchPath(window.location.pathname, {
    path: ROUTES.settings.editEfaxTemplate(":id"),
    exact: true,
    strict: false,
  });

  return {
    templateId: match?.params?.id ? Number(match.params.id) : undefined,
  };
};
